
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/telegram-bot",
      function () {
        return require("private-next-pages/[locale]/telegram-bot/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/telegram-bot"])
      });
    }
  